// extracted by mini-css-extract-plugin
export var takeOver__closeWrapper = "takeOver-module--takeOver__closeWrapper--PVm-M";
export var takeOver__column = "takeOver-module--takeOver__column--J6rHN";
export var takeOver__columnCta = "takeOver-module--takeOver__columnCta--kqwlj";
export var takeOver__columnNarrow = "takeOver-module--takeOver__columnNarrow---x4Id";
export var takeOver__columnPreamble = "takeOver-module--takeOver__columnPreamble--wLawC";
export var takeOver__columnWide = "takeOver-module--takeOver__columnWide--H5070";
export var takeOver__contact = "takeOver-module--takeOver__contact--kw+9L";
export var takeOver__content = "takeOver-module--takeOver__content--bnYM0";
export var takeOver__counter = "takeOver-module--takeOver__counter--y9K-W";
export var takeOver__counterBody = "takeOver-module--takeOver__counterBody--MdXkT";
export var takeOver__counterDivider = "takeOver-module--takeOver__counterDivider--UfQbB";
export var takeOver__counterDividerDot = "takeOver-module--takeOver__counterDividerDot--WgqU+";
export var takeOver__counterFooter = "takeOver-module--takeOver__counterFooter--nJt6X";
export var takeOver__counterHeader = "takeOver-module--takeOver__counterHeader--+4oTW";
export var takeOver__counterNumber = "takeOver-module--takeOver__counterNumber--fNtxh";
export var takeOver__counterTitle = "takeOver-module--takeOver__counterTitle--HT-Db";
export var takeOver__counterWrapper = "takeOver-module--takeOver__counterWrapper--KYqeF";
export var takeOver__embedWrapper = "takeOver-module--takeOver__embedWrapper--JmTuT";
export var takeOver__header = "takeOver-module--takeOver__header--TvgOe";
export var takeOver__logo = "takeOver-module--takeOver__logo--Wq097";
export var takeOver__row = "takeOver-module--takeOver__row--EndCD";
export var takeOver__rowColumns = "takeOver-module--takeOver__rowColumns--v7qiD";
export var takeOver__seasonCard = "takeOver-module--takeOver__seasonCard--3EZ8w";
export var takeOver__service = "takeOver-module--takeOver__service--gEtQS";
export var takeOver__textBlock = "takeOver-module--takeOver__textBlock--oC92D";
export var takeOver__timeLine = "takeOver-module--takeOver__timeLine--hlUwq";
export var takeOver__video = "takeOver-module--takeOver__video--ZrzE1";
export var takeOver__wrapper = "takeOver-module--takeOver__wrapper--0dWRS";
export var takeoverNoScroll = "takeOver-module--takeoverNoScroll--wElCI";